import React, { useEffect } from 'react';
import './style.css';
export const ApplePayButton = ({ applePayOptions = {}, authEventHandler, setApplePayButtonSeen, view }) => {
    useEffect(() => {
        setApplePayButtonSeen(true);
    }, []);
    useEffect(() => {
        authEventHandler({
            event: 'applePayButtonShown',
            data: {
                view: view || 'public_credential',
            },
        });
    }, [view]);
    return (React.createElement("div", { className: "applePayButtonContainer", onClick: () => {
            authEventHandler({
                event: 'applePayClicked',
                data: {
                    view: view || 'public_credential',
                },
            });
        } },
        React.createElement("button", { lang: applePayOptions.lang || 'en', style: {
                ApplePayButtonType: applePayOptions.type || 'plain',
                ApplePayButtonStyle: applePayOptions.style || 'white',
            }, className: "applePayButton" })));
};
